import React from "react";
import "./breadcrumb.scss";
import { Link } from "gatsby";

const Breadcrumb = ({ breadcrumbLinks }) => {
  return (
    <>
      <ul className="breadcrumb">
        {breadcrumbLinks &&
          breadcrumbLinks.map((item, index) =>
            index !== breadcrumbLinks.length - 1 ? (
              <li className="item" key={index}>
                <Link
                  to={item.uri}
                  itemProp="url"
                  className="link"
                >
                  {item.name}
                </Link>
              </li>
            ) : (
              <li className="item" key={index}>
                <span className="link">{item.name}</span>
              </li>
            )
          )}
      </ul>
    </>
  );
};

export default Breadcrumb;
